// extracted by mini-css-extract-plugin
export default {"root":"Dropdown-root-d1e0c8f4df2be751a552126e8c8d70f4"};